import { useCallback, useMemo } from 'react';
import Select from 'react-select';
import type { FolderOption } from '@trinity/chat-components/utils';
import styles from './style/FolderSelect.module.css';

type Props = {
  className?: string;
  options: FolderOption[];
  onChange: (folderId: string | null) => unknown;
  value: string | null;
};

type SelectOption = {
  value: string | null;
  label: string;
};

export const FolderSelect = ({ className, options, onChange, value }: Props) => {
  const selectOptions: SelectOption[] = useMemo(() => {
    return options.map(option => ({
      value: option.id,
      label: option.path,
    }));
  }, [options]);

  const handleChange = useCallback((selectedOption: SelectOption | null) => {
    onChange(selectedOption?.value || null);
  }, [onChange]);

  const selectedOption = useMemo(() => {
    return selectOptions.find(option =>
      value ? option.value === value : option.value === null,
    ) || selectOptions[0];
  }, [selectOptions, value]);

  return (
    <div className={className}>
      <Select
        className={styles.select}
        classNamePrefix="folder-select"
        value={selectedOption}
        onChange={handleChange}
        options={selectOptions}
        isSearchable={false}
        menuPlacement="auto"
      />
    </div>
  );
};

export default FolderSelect;
